export const MEDIA_QUERIES = {
  DESKTOP: "@media screen and (min-width: 1080px)",
  TABLET: "@media screen and (min-width: 700px)",
  DARK: "@media (prefers-color-scheme: dark)",
};